import { Table, message, Button, Row, Col, Pagination, Image } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import SearchProps from "../../../component/SearchProps";
import dayjs from "dayjs";
import axiosInstance from "../../../utils/axios";

export default function MakeMoneyManage() {
  const [makeMoney, setMakeMoney] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
  });

  const fetchMakeMoney = async () => {
    await axiosInstance.get(`/make-money/getAll`, {params: pagination})
      .then((res) => {
        const data = res?.data;
        setMakeMoney(data);
      })
      .catch(() => message.error("Error server!"));
  };

  useEffect(() => {
    fetchMakeMoney();
  }, [pagination]);

  const columns = [
    {
      title: <div>ID</div>,
      key: "make_money_id",
      dataIndex: "make_money_id",
      width: 100,
      sorter: (a, b) => a.make_money_id - b.make_money_id,
      render: (_, record) => <div>{record?.make_money_id}</div>,
    },
    {
      title: <div>Tên</div>,
      key: "make_money_tittle",
      dataIndex: "make_money_tittle",
      width: 150,
      ...SearchProps("make_money_tittle"),
      render: (_, record) => <div>{record?.make_money_tittle}</div>,
    },
    {
      title: <div>Ảnh</div>,
      key: "make_money_image",
      dataIndex: "make_money_image",
      width: 150,
      render: (_, record) => <div><Image src={record?.make_money_image} width={100} height={100}/></div>,
    },
    {
      title: <div>Tiền thưởng</div>,
      key: "money",
      dataIndex: "money",
      width: 150,
      sorter: (a, b) => a.money - b.money,
      render: (_, record) => <div>{record?.money}</div>,
    },
    {
      title: <div className={"base-table-cell-label "}>Ngày tạo</div>,
      key: "create_at",
      dataIndex: "create_at",
      width: 100,
      sorter: (a, b) => dayjs(a.create_at) - dayjs(b.create_at),
      render: (_, record) => {
        return (
          <div className={"cursor-pointer text-[14px] font-normal"}>
            <span className={"!inline-block min-w-[100px]"}>
              {dayjs(record?.create_at).format("DD/MM/YYYY")}
            </span>
          </div>
        );
      },
    },
    {
      key: "operation",
      dataIndex: "operation",
      width: 50,
      render: (_, record) => {
        return (
          <Link
            to={`/admin/quan-ly-make-money/${record?.make_money_id}`}
            className={"text-[var(--blue)]"}
          >
            <EditOutlined />
          </Link>
        );
      },
    },
  ];

  return (
    <>
      <div>
        <Row gutter={10} className={"mb-[8px]"}>
          <Col flex={1}>
            <div className={"text-[20px] font-medium"}>Quản lý kiếm tiền</div>
          </Col>
          <Col>
            <Link to={"/admin/quan-ly-make-money/tao-moi"}>
              <Button type={"primary"} onClick={() => {}}>
                Tạo
              </Button>
            </Link>
          </Col>
        </Row>
      </div>
      <div className="w-full h-full mt-5 pb-20 relative">
        <Table
          className={"custom-table"}
          dataSource={makeMoney?.data}
          columns={columns}
          pagination={false}
          scroll={{ x: 'max-content' }}
        />
        <Pagination
          className="flex justify-center absolute inset-x-0 bottom-10"
          current={pagination.page}
          total={makeMoney?.total}
          pageSize={pagination.pageSize}
          showSizeChanger
          onChange={(p, ps)=> {
            setPagination({
              page: p,
              pageSize: ps
            })
          }}
        />
      </div>
    </>
  );
}
